import { Modal, Input, Button, Tooltip, message, Divider } from "antd";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import LeadService from "../../services/LeadService";
import {
  CopyOutlined,
  LinkOutlined,
  MailOutlined,
  WhatsAppOutlined,
  MobileOutlined,
} from "@ant-design/icons";

const SellDialog = ({ open, onClose, category_id, product }) => {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [sellLink, setSellLink] = useState("");

  useEffect(() => {
    if (open) {
      setMobile("");
      setSellLink("");
    }
  }, [open, product]);

  const getSellLink = async () => {
    setLoading(true);
    try {
      const result = await LeadService.getAuthorization(
        category_id,
        product.id,
        mobile
      );

      if (!result.success) {
        return Swal.fire("Oops!", result.message || "Failed to fetch", "error");
      }

      const responseData = result.data;
      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        setSellLink(data.link);
        message.success("Link generated!");
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      message.error("Error fetching link");
    } finally {
      setLoading(false);
    }
  };

  // const whatsappMessage = `🔥 Exciting Offer!\n\nCheck out this product: *${product.name}*\n\nBuy now 👉 ${sellLink}`;
  // const emailSubject = `🔥 Check this product: ${product.name}`;
  // const emailBody = `Hi,\n\nI found this amazing product: ${product.name}.\nClick to view and purchase:\n${sellLink}\n\nCheers!`;

  const offerType = product.name; // or Savings / Demat / Personal Loan

  const whatsappMessage = `💳 Special ${offerType} Offer!\n\nApply for *${product.name}* and enjoy exclusive benefits.\n\nGet started 👉 ${sellLink}\n\nHurry! Limited time offer.`;

  const emailSubject = `💳 Get Your ${offerType}: ${product.name}`;

  const emailBody = `Hi,\n\nLooking for the best ${offerType}? Check out *${product.name}*.\n\nClick below to apply and enjoy special rewards:\n👉 ${sellLink}\n\nCheers,\n`;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      title={null}
    >
      <div style={{ textAlign: "center" }}>
        {product.logo && (
          <img
            src={product.logo}
            alt={product.name}
            style={{
              width: 60,
              height: 60,
              borderRadius: 12,
              marginBottom: 10,
            }}
          />
        )}
        <h4 style={{ marginBottom: 8, color: "#1a1a1a" }}>{product.name}</h4>
        <p style={{ fontSize: 14, color: "#666" }}>
          Earn by sharing this product with others!
        </p>
      </div>

      <Divider />

      <p style={{ fontWeight: 500, marginBottom: 6 }}>
        Customer's Mobile Number:
      </p>
      <Input
        //   size="large"
        placeholder="Enter mobile number"
        prefix={<MobileOutlined />}
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
        maxLength={10}
        style={{ marginBottom: 24, height: 40, fontSize: 14 }}
      />

      <Button
        type="primary"
        loading={loading}
        block
        onClick={getSellLink}
        style={{ marginBottom: 24, height: 40, fontSize: 14 }}
      >
        Generate Referral Link
      </Button>

      {sellLink && (
        <div
          style={{
            background: "#fafafa",
            padding: 16,
            borderRadius: 8,
            boxShadow: "0 0 4px rgba(0,0,0,0.05)",
          }}
        >
          <p style={{ fontWeight: 500, marginBottom: 8 }}>Generated Link:</p>
          <Input value={sellLink} readOnly style={{ marginBottom: 12 }} />

          <div className="d-flex flex-wrap gap-2 justify-content-between">
            <Tooltip title="Copy to Clipboard">
              <Button
                icon={<CopyOutlined />}
                onClick={() => {
                  navigator.clipboard.writeText(sellLink);
                  message.success("Copied to clipboard!");
                }}
              >
                Copy
              </Button>
            </Tooltip>

            <Tooltip title="Open Link in New Tab">
              <Button
                icon={<LinkOutlined />}
                onClick={() => window.open(sellLink, "_blank")}
              >
                Visit
              </Button>
            </Tooltip>

            <Tooltip title="Share via WhatsApp">
              <Button
                icon={<WhatsAppOutlined />}
                style={{ backgroundColor: "#25D366", color: "#fff" }}
                onClick={() => {
                  window.open(
                    `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`
                  );
                }}
              >
                WhatsApp
              </Button>
            </Tooltip>

            <Tooltip title="Send via Email">
              <Button
                icon={<MailOutlined />}
                style={{ backgroundColor: "#f5222d", color: "#fff" }}
                onClick={() => {
                  window.location.href = `mailto:?subject=${encodeURIComponent(
                    emailSubject
                  )}&body=${encodeURIComponent(emailBody)}`;
                }}
              >
                Email
              </Button>
            </Tooltip>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default SellDialog;
